<span>{{date | date: toFormat: timezone :translateService.currentLang}}</span>
